import * as React from "react"
// import styled from "styled-components"
import Moment from "react-moment"
import { FetchSingleListingPictures, FetchSingleListingOwner } from "../../generated/graphql"
import Box from "../box"
import Text from "../text"
import Avatar from "../avatar"
import moment from "moment"
import styled from "styled-components"

const HeadingH2 = styled.h2`
  text-decoration: none;
  margin-bottom: 18px;
  color: rgb(60, 66, 64);
  font-size: 32px;
  font-weight: 600;
`
interface Props {
  pictures?: Array<FetchSingleListingPictures>
  owner: FetchSingleListingOwner
}

interface State {}

class SingleListingLandlord extends React.PureComponent<Props, State> {
  state = {}
  render() {
    const { owner } = this.props
    return (
      <Box flexDirection="column" mb={[5]}>
        <HeadingH2 fontSize={[5]} color="black" fontWeight={600} mb={[3]}>
          Listed by
        </HeadingH2>
        <Box>
          <Box width={["70%"]} pr={[2]} flexDirection="column">
            <Text color="black" style={{ opacity: 0.5 }}>
              {owner.city && `${owner.city}  ·`} Joined{" "}
              <Moment fromNow>{moment.unix(owner.createdAt / 1000)}</Moment>
            </Text>
            <Text mt={[2]} style={{ lineHeight: 1.44 }} color="black">
              {owner.bio}
            </Text>
          </Box>
          <Box width={["30%"]} flexDirection="column" alignItems="center">
            <Avatar imageURL={owner.avatarUrl || "/images/default-profile-picture.png"} />
            <Text mt={[2]} textAlign="center">
              {owner.firstName}
            </Text>
            {/* <Text mt={[2]}>{owner.phone}</Text> */}
          </Box>
        </Box>
      </Box>
    )
  }
}

export default SingleListingLandlord
